import { Theme } from '@mui/material/styles'

const useStyles = {
  chipIcon: (theme: Theme) => ({
    display: 'flex',
    marginRight: theme.spacing(0.5),
    [theme.breakpoints.down('lg')]: {
      display: 'none',
    },
  }),
  accountsChip: (theme: Theme) => ({
    color: theme.palette.primary.dark,
    backgroundColor: theme.palette.primary.shades['4p'],
    '&:hover': {
      textDecoration: 'underline',
      cursor: 'pointer',
    },
    [theme.breakpoints.down('lg')]: {
      height: 'auto',
    },
  }),
  membershipChip: (theme: Theme) => ({
    [theme.breakpoints.down('lg')]: {
      height: 'auto',
    },
  }),
  activeMembershipChip: (theme: Theme) => ({
    color: theme.palette.success.dark,
    backgroundColor: theme.palette.success.shades['8p'],
  }),
  invitedMembershipChip: (theme: Theme) => ({
    color: theme.palette.warning.dark,
    backgroundColor: theme.palette.warning.shades['8p'],
  }),
  membershipChipLabel: (theme: Theme) => ({
    textTransform: 'capitalize',
    [theme.breakpoints.down('lg')]: {
      paddingX: theme.spacing(1),
    },
  }),
  menuItemWithIcon: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  dialogText: (theme: Theme) => ({
    marginBottom: theme.spacing(2),
  }),
  dialogTextImportant: (theme: Theme) => ({
    marginBottom: theme.spacing(2),
    textDecoration: 'underline',
  }),
  errorContainer: (theme: Theme) => ({
    marginTop: theme.spacing(3),
  }),
  gridToolbarTitleContainer: {
    padding: '0 10px',
  },
  moreOptionsBtnSelected: (theme: Theme) => ({
    backgroundColor: theme.palette.primary.shades['8p'],
  }),
  preferencesContainer: (theme: Theme) => ({
    [theme.breakpoints.down('lg')]: {
      gap: 0,
    },
  }),
  preferenceIcon: {
    display: 'flex',
    alignSelf: 'center',
  },
  copyIconButton: {
    marginLeft: 'auto',
  },
}
export default useStyles
